import React from 'react'

import Box from '@material-ui/core/Box'

import TasksBox from '../components/TasksBox';

function Tasks() {
  return (
    <div>
      <Box paddingTop={3}>

      <TasksBox/>
      </Box>
    </div>
  )
}

export default Tasks
